import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function WhyItWorksSection() {
  return <section className="py-24 px-4 bg-[#0F1419] text-[#F5F0E8] border-t border-[#1A1F2E]" data-id="element-382">
      <div className="max-w-4xl mx-auto text-center" data-id="element-383">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-384">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-385">
            Por qué esto funciona <br data-id="element-386" />
            <span className="text-[#8B8578] text-2xl font-normal" data-id="element-387">
              (cuando lo demás falla)
            </span>
          </h2>
          <p className="text-lg text-[#8B8578] max-w-2xl mx-auto" data-id="element-388">
            Porque cambia tu comunicación radicalmente.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center mb-16" data-id="element-389">
          {/* Before */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#1A1F2E]/50 p-8 rounded-2xl border border-[#C75B3A]/20" data-id="element-390">
            <p className="text-sm text-[#8B8578] uppercase tracking-widest mb-4" data-id="element-391">
              Antes
            </p>
            <p className="text-2xl font-serif text-[#C75B3A] line-through decoration-2 decoration-[#C75B3A]/50" data-id="element-392">
              “¿Todo bien?”
            </p>
          </motion.div>

          {/* Arrow */}
          <div className="flex justify-center" data-id="element-393">
            <ArrowRight className="w-8 h-8 text-[#D4A843] rotate-90 md:rotate-0" data-id="element-394" />
          </div>

          {/* After */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#1A1F2E] p-8 rounded-2xl border border-[#4A8B6E]/50 shadow-[0_0_30px_rgba(74,139,110,0.1)]" data-id="element-395">
            <p className="text-sm text-[#4A8B6E] uppercase tracking-widest mb-4 font-bold" data-id="element-396">
              Ahora
            </p>
            <p className="text-lg font-bold text-[#F5F0E8]" data-id="element-397">
              “Confirma <span className="text-[#4A8B6E]" data-id="element-398">sí/no</span>,{' '}
              <span className="text-[#4A8B6E]" data-id="element-399">fecha/hora</span>, y{' '}
              <span className="text-[#4A8B6E]" data-id="element-400">quién es owner</span>. Gracias.”
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#0B0E13] p-8 rounded-2xl border border-[#D4A843]/20" data-id="element-401">
          <p className="text-lg text-[#8B8578] leading-relaxed" data-id="element-402">
            Esa sola estructura hace que la gente te responda distinto. <br data-id="element-403" />
            <span className="text-[#F5F0E8] font-bold" data-id="element-404">
              Ya no estás pidiendo calma. Estás pidiendo hechos.
            </span>
            <br data-id="element-405" />
            <br data-id="element-406" />Y cuando hay un error real (en CD, fees, credits), te da un
            modelo para que no se convierta en una guerra… pero tampoco en un
            “ya ni modo”.
          </p>
        </motion.div>
      </div>
    </section>;
}